import Main from "./Main";

/**
 * Set defaults
 * @this {MainClassProps}
 */
Main.prototype.defaults = function () {
  this.dataset = "";
  this.shift = [];
  this.attributes = [];
  this.css = [];
  this.cssInitials = new Map();
  this.store = new Map();
  this.variables = new Map();
  this.initials = new Map();
  this.parents = new Map();
  this.events = new Map();
  this.listeners = new Set();
  this.triggers = new Map();
  this.activeTriggers = new Set();
  this.activeProperties = new Map();
  this.applied = new Map();
  this.targeted = new Map();
  this.appliedInitials = new Map();
  this.storage = new Map([
    ["values", []],
    ["properties", []],
    ["variables", []],
    ["parameters", []],
    ["merges", []],
    ["parent-refs", []],
    ["timelines", []],
    ["functions", []],
  ]);
  this.SVGOffset = {
    initialized: false,
    parent: null,
    path: null,
    matrix: null,
    computed: {
      x: 0,
      y: 0,
      r: 0,
    },
    reduced: 0,
    rotation: 0,
  };
  this.isVisible = true;
  this.isImmediate = false;
};

export default Main.prototype.defaults;
